export default "__VITE_ASSET__qfxXfxZx__"